import React from "react";
import PropTypes from "prop-types";

// This component is to be used in AG Grid cellRenderer for rendering email information
const EmailCellRenderer = ({ value }) => {
  return (
    <div style={{ lineHeight: "1.4", whiteSpace: "normal" }}>
      {value?.map((email, numberIndex) => (
        <p
          key={numberIndex}
          style={{ marginBottom: numberIndex < value.length - 1 ? "2px" : "0" }}
        >
          {email}
        </p>
      ))}
    </div>
  );
};

EmailCellRenderer.propTypes = {
  /** The cell value to render */
  value: PropTypes.arrayOf(PropTypes.string),
};

export default React.memo(EmailCellRenderer);
